import { muxService } from './muxService';
import { supabase } from './supabase';

export const streamChatService = {
  // Get real-time viewer count from Mux
  async getViewerCount(streamId) {
    try {
      const response = await muxService.getLiveStream(streamId, true);
      return response?.data?.active_viewer_count || 0;
    } catch (err) {
      return 0;
    }
  },

  // Send chat message
  async sendMessage(streamId, username, message, isAdmin = false, userId = null) {
    try {
      const { data, error } = await supabase
        .from('live_chat')
        .insert({
          stream_id: streamId,
          username,
          message,
          is_admin: isAdmin,
          discord_id: userId
        })
        .select();

      if (error) throw error;
      return data;
    } catch (err) {
      console.error('Error sending message:', err);
      throw err;
    }
  },

  // Get chat messages for a stream
  async getMessages(streamId, limit = 50) {
    try {
      const { data, error } = await supabase
        .from('live_chat')
        .select('id, username, message, is_admin, created_at, discord_id, discord_username')
        .eq('stream_id', streamId)
        .order('created_at', { ascending: true })
        .limit(limit);

      if (error) throw error;
      return data || [];
    } catch (err) {
      console.error('Error fetching messages:', err);
      return [];
    }
  },

  // Subscribe to real-time chat messages
  subscribeToChat(streamId, callback) {
    const subscription = supabase
      .from(`live_chat:stream_id=eq.${streamId}`)
      .on('*', (payload) => {
        callback(payload);
      })
      .subscribe();

    return subscription;
  },

  // Delete a message (admin only)
  async deleteMessage(messageId) {
    try {
      const { error } = await supabase
        .from('live_chat')
        .delete()
        .eq('id', messageId);

      if (error) throw error;
    } catch (err) {
      console.error('Error deleting message:', err);
      throw err;
    }
  },

  // Clear all messages for a stream (admin only)
  async clearChat(streamId) {
    try {
      const { error } = await supabase
        .from('live_chat')
        .delete()
        .eq('stream_id', streamId);

      if (error) throw error;
    } catch (err) {
      console.error('Error clearing chat:', err);
      throw err;
    }
  }
};
